// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { commonShortFieldLabels } from "./common-short-fields";
import { platformAdminAssetsObjectSpaces } from "./platform-admin-assets-object-spaces";

export const platformAdminAssetsManagement = {
  columns: {
    filename: "Filename",
    assetId: "Asset ID",
    objectSpace: "Object Space",
    storage: "Storage",
    size: "Size",
    references: "References",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "Actions",
    owner: "Owner",
    ownerSubject: "Owner Subject",
    uploader: "Uploader",
    inUse: "In Use",
    service: "Service",
    scope: "Scope",
    resourceType: "Resource Type",
    resourceId: "Resource ID",
    field: "Field",
    label: "Description",
    businessService: "Business Service",
    bindingCount: "Bindings",
    assetCountRef: "Related Assets",
    note: "Note",
    shareMode: "Share Mode",
    shareState: "Share State",
    ...platformAdminAssetsObjectSpaces.columns,
  },
  actions: {
    governanceDetail: "Governance Detail",
    share: "Share",
    clone: "Clone to My Assets",
    uploadToMySpace: "Upload File",
    viewMySpacePolicy: "View Space Policy / Quota",
    copyDownloadLink: "Copy Download Link",
    editNote: "Edit Note",
    shareToPublic: "Share to Public",
    cancelPublicShare: "Cancel Sharing",
    copyToMySpaceRecommended: "Copy to My Space (Recommended)",
    ...platformAdminAssetsObjectSpaces.actions,
  },
  drawer: {
    referenceBindingCatalogDetail: "Binding Details · {service} / {scope} / {resourceType}",
    referenceAssetCatalogDetail: "Related Assets · {service} / {scope} / {resourceType}",
    ...platformAdminAssetsObjectSpaces.drawer,
  },
  fields: {
    note: "Note",
    ...platformAdminAssetsObjectSpaces.fields,
  },
  form: {
    removeAssetTitle: "Delete File",
    removeAssetDescription: "Delete {name}? Referenced assets will be blocked.",
    assetNoteTitle: "Edit Note · {name}",
    assetNoteTitleShort: "Edit Note",
    noSelectedAsset: "No file selected",
    note: "Note",
    sharePublicTitle: "Share to Public",
    sharePublicDescription:
      "Share {name} to the public shared directory? Ownership remains with the current user after sharing.",
    unsharePublicTitle: "Cancel Sharing",
    unsharePublicDescription:
      "Cancel public sharing for {name}? If other modules already reference this asset, the operation will be blocked.",
    ...platformAdminAssetsObjectSpaces.form,
  },
  errors: {
    loadFailed: "Failed to read asset center data",
    mySpaceLoadFailed: "Failed to load my space",
    mySpaceUploadFailed: "Failed to upload to my space",
    mySpaceDeleteFailed: "Failed to delete file from my space",
    mySpaceNoteUpdateFailed: "Failed to update file note",
    publicBrandingLoadFailed: "Failed to load public branding catalog",
    publicBrandingDeleteFailed: "Failed to delete file from public branding catalog",
    publicBrandingNoteUpdateFailed: "Failed to update public branding note",
    sharePublicFailed: "Failed to share to public",
    unsharePublicFailed: "Failed to cancel sharing",
    copyToMySpaceFailed: "Failed to copy to my space",
    cloneFailed: "Failed to clone asset",
    uploadRequestIncomplete: "Upload request response is incomplete",
    uploadCompleteMissingAsset: "Upload completed without returning asset_id",
    governanceDetailLoadFailed: "Failed to load asset governance detail",
    ...platformAdminAssetsObjectSpaces.errors,
  },
  messages: {
    sharePublicSuccess: "{name} shared to public directory",
    unsharePublicSuccess: "{name} is no longer publicly shared",
    copyToMySpaceSuccess: "{name} copied to my space",
    cloneSuccess: "Asset cloned to my assets",
  },
  objects: {
    ...platformAdminAssetsObjectSpaces.objects,
  },
} as const;
